import styled from "styled-components";

export const StyledOuterWrapper = styled.div`
  width: 60px;
  height: 60px;
  margin-right: 15px;
  flex-shrink: 0;
`;

export const StyledInnerWrapper = styled.figure`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
`;

export const StyledQuantityWrapper = styled.div`
  position: absolute;
  bottom: 10px;
`;
